import { Component, OnInit, ViewChild } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { Table } from 'primeng/table';
import { CommonService } from '../../../core/common/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { GroupDTO } from '../../model/group.entity';
import { Dropdown } from 'primeng/dropdown';
import { MasterDataRepository } from '../../../core/data/repositories/masterdata.repository';

@Component({
  selector: 'tandc-group',
  templateUrl: './group.component.html'
})
export class GroupComponent implements OnInit {

  groupList: GroupDTO[] = [];
  model: GroupDTO = new GroupDTO();
  typeList: Dropdown[] = [];
  organisationalUnitList: Dropdown[] = [];
  showModal: boolean = false;
  modalTitle: string = "";
  @ViewChild('dt')
  dt!: Table;

  constructor(private service: AdminService,
    private commonService: CommonService,
    private translate: TranslateService,
  private masterDataRepository: MasterDataRepository) { }

  ngOnInit(): void {
    this.getAll();
  }

  applyFilterGlobal($event: any, stringVal: any) {
    this.dt!.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }

  getAll() {
    this.service.getGroup().subscribe((x) => {
      this.groupList = x.value;
    });

    this.service.getGroupType().subscribe((x) => {
      this.typeList = x.value;
    });

    this.service.getOrganisationalUnit().subscribe((x) => {
      this.organisationalUnitList = x.value;
    });
  }

  addModal() {
    this.model = new GroupDTO();
    this.showModal = !this.showModal;
    this.modalTitle =
      this.translate.instant('commonbtn.add') +
      ' ' +
      this.translate.instant('Master.grp');
  }

  save(data: GroupDTO) {
    if (data.id > 0) {
      this.service.updateGroup(data).subscribe((res) => {
        if (res) {
          this.showModal = !this.showModal;
          this.commonService.successMessage(
            this.translate.instant('Alerts.UpdatedSuccessfully')
          );
          this.getAll();
        }
      });
    } else {
      this.service.saveGroup(data).subscribe((res) => {
        if (res) {
          this.showModal = !this.showModal;
          this.commonService.successMessage(
            this.translate.instant('Alerts.SavedSuccessfully')
          );
          this.getAll();
        }
      });
    }
  }

  delete(data: GroupDTO) {
    this.commonService.confirmationService.confirm({
      message: this.translate.instant('Alerts.DeleteConfirmation'),
      accept: () => {
        if (data) {
          this.service.deleteGroup(data.id).subscribe((res) => {
            if (res) {
              this.commonService.successMessage(
                this.translate.instant('Alerts.DeleteSuccessfully')
              );
              this.getAll();
            }
          });
        }
      },
    });
  }

    onToggleStatus(item: GroupDTO) {
  const updatedItem = { ...item }; 
  this.service.updateGroup(updatedItem).subscribe({
    next: () => {
      this.commonService.successMessage(
        this.translate.instant('Alerts.UpdatedSuccessfully')
      );
    },
    error: () => {
      this.commonService.errorMessage(
        this.translate.instant('Alerts.ErrorOccured')
      );
      // Revert toggle on error
      item.isActive = !item.isActive;
    }
  });
  }

  edit(data: GroupDTO) {
    this.modalTitle = this.translate.instant('common.update') + ' ' + this.translate.instant('Master.grp');
    this.model = data;
    this.showModal = !this.showModal;
  }

   downloadFile(blob: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  export() {
    this.masterDataRepository.export('group').subscribe(blob => {
      this.downloadFile(blob, `group-${new Date().toISOString().slice(0,10)}.xlsx`);
    });
  }



}
